function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_187",
  "data-name": "Path 187",
  d: "M10.054,272.129a2.13,2.13,0,0,0-2.117,2.117.794.794,0,1,0,1.588,0,.511.511,0,0,1,.529-.529H20.638a.512.512,0,0,1,.529.529v14.817a.512.512,0,0,1-.529.529.794.794,0,1,0,0,1.588,2.13,2.13,0,0,0,2.117-2.117V274.246a2.13,2.13,0,0,0-2.117-2.117Zm-4.233,4.233A2.13,2.13,0,0,0,3.7,278.479V293.3a2.13,2.13,0,0,0,2.117,2.117H16.4a2.13,2.13,0,0,0,2.117-2.117V278.479a2.13,2.13,0,0,0-2.117-2.117Zm0,1.587H16.4a.512.512,0,0,1,.529.529V293.3a.512.512,0,0,1-.529.529H5.821a.511.511,0,0,1-.529-.529V278.479A.512.512,0,0,1,5.821,277.95Z",
  transform: "translate(-3.704 -272.129)",
  fill: "#9a9a9a",
  fillRule: "evenodd"
});

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.05,
    height: 23.283,
    viewBox: "0 0 19.05 23.283",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.58f2486b.svg";
export { ForwardRef as ReactComponent };